import { FEATURE_ACTION_VIEW } from "../../feature/constants"
import { useFeatureViewPermission } from "../../feature/permissions"
import { useCommunityContext } from "../Community"
import { COMMUNITY_FEATURE_VISIBILITY_MAP } from "../constants"
import useCommunityAreas from "./useCommunityAreas"

// helper for providing expected options to useFeatureViewPermission
const useCommunityAreaFeaturePermission = (options = {}) => {
  const { resourceId, cohortId } = useCommunityContext()
  const communityAreas = useCommunityAreas()

  return useFeatureViewPermission({
    featureKey:
      options.featureKey ||
      COMMUNITY_FEATURE_VISIBILITY_MAP[communityAreas.selectedArea.id],
    featureAction: FEATURE_ACTION_VIEW,
    context: {
      resource_id: resourceId,
      cohort_id: cohortId
    }
  })
}

export default useCommunityAreaFeaturePermission
